import { useInteractiveBrowserCredential } from '@internal/plugin-azure-resources-common-react';
import { useDebounce } from 'react-use';

import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';

export const KAAP_API_TOKEN_SECRET_KEY = 'KAAP_API_TOKEN';

/**
 * Silently acquires an Azure token scoped to the KaaP API (`${kaap.apiUrl}/.default`)
 * and stores it under `secrets.KAAP_API_TOKEN` so scaffolder steps can use it.
 *
 * Renders nothing — add it as a hidden field in a wizard step.
 */
export const KaapAzureToken = () => {
  const config = useApi(configApiRef);
  const { setSecrets } = useTemplateSecrets();
  const credentials = useInteractiveBrowserCredential();

  const kaapApiUrl = config.getString('kaap.apiUrl');
  const scope = `${kaapApiUrl}/.default`;

  useDebounce(async () => {
    const accessToken = await credentials.getToken([scope]);
    if (accessToken?.token) {
      setSecrets({ [KAAP_API_TOKEN_SECRET_KEY]: accessToken.token });
    }
  }, 1000);

  return null;
};
